/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NotificationRegistrationKey } from './notificationRegistrationKey';


/**
 * The response to update a notification registration status
 */
export interface NotificationRegistrationStatusUpdateResponse { 
    notificationRegistrationKey: NotificationRegistrationKey;
    /**
     * The status of the notification registration
     */
    notificationRegistrationStatus: string;
}
